<a class="pull-left {{iconCssClass}}">
    <p class="day"><ng-content></ng-content></p>
</a>
